<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			invoicedetailgroupdata: {
				default: () => {
					return {}
				}
			},
			store: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '预计出库成本余额',
				modal_width:800,
				modal_height:600,
				list_footerField:[
					{field:'price',toFixed:4},
					{field:'endAmount',toFixed:4}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50
					},{
						field: 'inventoryName',
						title: '项目名称',
						sortable:true,
					},
					{
						field: 'price',
						title: '入库金额',
						sortable:true,
					},
					{
						field: 'endAmount',
						title: '结存金额',
						sortable:true,
						slots:{
							default:({row})=>{
								if(row.endAmount<0){
									return <span style="color:#F56C6C">{row.endAmount}</span>
								}else{
									return row.endAmount
								}
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = false
			},
			list() {
				return new Promise((resolve) => {
					let data = []
					// console.log(this.invoicedetailgroupdata)
					// console.log(this.store.inventoryreport)
					let inventoryreport = JSON.parse(JSON.stringify(this.store.inventoryreport))
					let groupdata = this.$Lodash.groupBy(inventoryreport, 'inventoryName')
					for(let i in groupdata){
						let obj = groupdata[i][0]
						obj.endAmount = this.$Lodash.sumBy(groupdata[i], (item)=>{return parseFloat(item.endAmount)})
						if(this.invoicedetailgroupdata[obj.inventoryName]){
							obj.price = this.invoicedetailgroupdata[obj.inventoryName].price
						}else{
							obj.price = 0
						}
						obj.endAmount = obj.endAmount + parseFloat(obj.price)
						obj.endAmount = obj.endAmount.toFixed(4)
						data.push(obj)
					}
					resolve({
						list: data
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>